// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectDefaultAssumptionQueryResult, selectDefaultAssumptionsPageLoading, selectDefaultAssumptionsShowInitWaitingMessage} from '../_selectors/default-assumption.selectors';

export class DefaultAssumptionsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectDefaultAssumptionsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectDefaultAssumptionsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectDefaultAssumptionQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
